import { StatusCommissionSplitsTypes } from "types";

export const getCommissionStatusDisplayName = value => {
	const status =
		value === true
			? StatusCommissionSplitsTypes.Available.value
			: StatusCommissionSplitsTypes.Unavailable.value;
	const statusType = StatusCommissionSplitsTypes.getByValue(status);
	return statusType?.displayName;
};
